import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Select extends Component {
  render() {
    let { id, onChange, label, style, value } = this.props;

    const options = this.props.options.map(function(option, index) {
      return (
        <option key={index} value={option.value}>
          {option.text}
        </option>
      );
    });

    return (
      <div>
        <label>{label ? label + ': ' : ''}</label>
        <select onChange={onChange} value={value} id={id} style={style}>
          {options}
        </select>
      </div>
    );
  }
}

Select.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  style: PropTypes.object,
  value: PropTypes.string,
};
